import { Button, message, Tooltip, Image, Spin } from 'antd'
import styles from './index.module.less'
import { CopyOutlined } from '@ant-design/icons'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import { useEffect, useRef, useState } from 'react'
import ComfirmModal from '../ConfirmModal'
import dayjs from 'dayjs'
import { isArray, isEmpty } from 'lodash-es'
import tagsMap from '../../utils'

export default function ProductList(props: any) {
  const {
    data,
    type,
    generalId,
    spaceId,
    budgetId,
    setSelectMaterialObj,
    multipleOpen,
    addType,
    btnInfo,
    getGeneralList,
    reload,
  } = props
  const [open, setOpen] = useState(false)
  const [record, setRecord] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const productListContainerRef = useRef(null)
  const clickToCopy = value => {
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = value
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    message.success('复制成功', 1)
  }
  const priceHandle = price => {
    if (price || price == 0) {
      let priceStr = numFormat({ value: price })
      const [int, dec] = priceStr.split('.')
      if (Number(dec)) {
        return (
          <>
            {int}
            <span className={styles.priceBoxSmall}>.{dec}</span>
          </>
        )
      } else {
        return int
      }
    }
  }
  const clickToAdd = record => {
    if (multipleOpen) {
      // 批量设置，按照原逻辑处理
      clickToSelect(record)
      return
    }
    record.checked = true // 选到右侧默认勾选
    record.spaceChecked = [] // 造数据 空间应用
    record.generalId = type === 'ADD' || type === 'PROJECT' ? '' : generalId
    record.calculate = ''
    record.type = type
    setRecord(record)
    // 如果套件明细数据，过滤调不显示的数据
    if (record.productSpu?.combinationInfo?.length > 1) {
      record.productSpu.combinationInfo = record.productSpu?.combinationInfo.filter(
        item => item.allowView
      )
      // 打开套件明细弹窗
      setOpen(true)
      return
    }
    // console.log(record, 'old')
    // // 如果有规格可以选择 提前选择
    // if (record.productSpu?.skuSize > 1) {
    //   setOpen(true)
    // } else {
    setOpen(true)
    // }
  }
  const getFunc = val => {
    let funcRes: any = ''
    try {
      const func = new Function(`return ${val}`)
      funcRes = func()
    } catch (err) {
      funcRes = false
    }
    funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
    return funcRes
  }

  const clickToSelect = record => {
    // 添加物料
    // const newData: any = _.cloneDeep(dataRef.current)
    console.log(record, 'record')

    record.checked = true // 选到右侧默认勾选
    record.spaceChecked = [] // 造数据 空间应用
    record.generalId = type === 'ADD' || type === 'PROJECT' ? '' : generalId
    record.calculate = ''
    // 区分通项和产品
    record.onlyShowTitle =
      (type === 'SUB' && record.referenceType === 'GENERAL') ||
      (type === 'ADD' && addType === 'GENERAL')
    record.type = type
    record.addType = addType
    setRecord(record)
    if (
      (record?.productSpu?.skuSize > 0 && !isEmpty(record?.productSpu?.skuList[0]?.argMap)) ||
      record?.skuDynamicVoList?.length > 0 ||
      record?.productSpu?.combinationInfo?.length > 1
    ) {
      setOpen(true)
    } else {
      let defaultSpaceInfo = record?.budgetItemList?.find(item => item.id === spaceId) || {}
      record.list = []
      if (!isEmpty(defaultSpaceInfo)) {
        record?.list.push({
          itemId: defaultSpaceInfo?.id, // 空间标识id,
          remark: '',
          budgetQtyValue: defaultSpaceInfo?.displayQtyFormular
            ? getFunc(defaultSpaceInfo?.displayQtyFormular)
            : '',
          budgetQtyFormular: defaultSpaceInfo?.displayQtyFormular,
        })
      }
      setSelectMaterialObj(record)
      message.success('已加入批量设置空间')
    }
    // }
  }
  const clickToDetail = record => {
    window.open(
      `/order/materialSelectionLibrary/materialDetail/${record?.productSpu?.id}`,
      '_blank'
    )
  }

  const showNationalTagRender = (item: any) => {
    if (item?.showTags && isArray(item?.showTags)) {
      return item.showTags?.map((tag: any) => {
        return (
          <div
            key={tag.tagCode}
            className={'normal_tag_style'}
            style={{
              color: tagsMap[tag.tagCode]?.color,
              backgroundColor: tagsMap[tag.tagCode]?.bgColor,
              marginRight: '8px',
            }}
          >
            <Tooltip title={tag.tagName}>{tag.tagName}</Tooltip>
          </div>
        )
      })
    }
    if (item?.packDtlList && item?.packDtlList.length) {
      return (
        <div
          className={'normal_tag_style'}
          style={{
            color: tagsMap.GROUP?.color,
            backgroundColor: tagsMap.GROUP?.bgColor,
            marginRight: '8px',
          }}
        >
          <Tooltip title={tagsMap.GROUP.name}>{tagsMap.GROUP.name}</Tooltip>
        </div>
      )
    }

    return <></>
  }
  const showProdCateTagRender = (tagName: any) => {
    if (tagName) {
      let strArray = tagName?.split('/')
      let str = strArray[strArray.length - 1]
      if (str) {
        return (
          // <div className={tagsMap.PROCATENAME}>
          //   <Tooltip title={str}>{str}</Tooltip>
          // </div>
          <div
            className={'normal_tag_style'}
            style={{
              color: tagsMap.PROCATENAME?.color,
              backgroundColor: tagsMap.PROCATENAME?.bgColor,
              marginRight: '8px',
              maxWidth: 'fit-content',
            }}
          >
            <Tooltip placement="top" arrow={false} title={str}>
              {str}
            </Tooltip>
          </div>
        )
      }
    }
  }
  useEffect(() => {
    const masonry: any = productListContainerRef?.current
    const items = masonry?.querySelectorAll('.productListContainer_item')
    masonry.style.gridTemplateColumns = multipleOpen
      ? `repeat(auto-fill, 100%)`
      : `repeat(auto-fill, 50%)`
    // // 获取当前列数
    masonry.style.marginBottom = '16px'
    items.forEach((item, index) => {
      // 根据元素高度设置元素的需占行数
      const rows = Math.ceil(item.clientHeight / 4) + 4
      item.style.gridRowEnd = `span ${rows}`
    })
  }, [data, multipleOpen])

  return (
    <div className={styles.productListContainer} ref={productListContainerRef}>
      {data?.map((item, index) => {
        if (type === 'ACTIVITY') {
          return (
            <div
              className={`${styles.productListContainer_item} productListContainer_item`}
              style={{ width: multipleOpen ? 'calc(100% - 4px)' : '480px' }}
            >
              <div className={styles.item_imgBox}>
                {/* <img src={item?.productSku?.mainPicUrl} alt="" /> */}
                <Image.PreviewGroup items={item?.productSku?.imageUrls || undefined}>
                  <Image src={item?.productSku?.mainPicUrl} />
                </Image.PreviewGroup>
              </div>
              <div className={styles.item_prodBox}>
                <div className={styles.nameBox} onClick={() => clickToDetail(item)}>
                  {/* {renderTags()} */}
                  {/* <Tooltip title={`【${item?.activity?.name}】 ${item.productSkuName}`}> */}【
                  {item?.activity?.name}】 {item.productSkuName}
                  {/* </Tooltip> */}
                </div>
                <p className={styles.spuBox}>
                  <span>SKU：</span>
                  {item?.productSkuId}
                  <CopyOutlined
                    style={{ marginLeft: '8px' }}
                    className="copyIcon"
                    onClick={() => {
                      clickToCopy(item?.productSkuId)
                    }}
                  />
                </p>
                <p className={styles.timeBox}>
                  活动时间：{dayjs(item?.activity?.startDate).format('YYYY-MM-DD HH:mm:ss')}至
                  {dayjs(item?.activity?.endDate).format('YYYY-MM-DD HH:mm:ss')}
                </p>
                <div className={styles.item_bottomBox}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div className={styles.priceBox}>
                      <span className={styles.priceBoxSmall}>￥</span>
                      {
                        <span>
                          {item?.productSkuSalePrice || item?.productSkuSalePrice == 0
                            ? item?.productSkuSalePrice
                            : '--'}
                        </span>
                      }
                      <span className={styles.priceBoxSmall}>/{item?.productSpuUnitName}</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#2D2D2E' }}>
                      <span style={{ margin: '0 8px' }}>{item?.limitTypeName}</span>
                      <span>
                        {item?.limitTypeName === '金额限制'
                          ? null
                          : item?.remainder || item?.remainder == 0
                            ? '剩余' + item?.remainder
                            : item?.remainder}
                        {/* {item?.remainder || 0
                          ? item?.limitTypeName !== '金额限制' && (item?.remainder || 0)
                          : null} */}
                      </span>
                    </div>
                  </div>
                  <Button type="primary" size="middle" onClick={() => clickToAdd(item)}>
                    添加优惠
                  </Button>
                </div>
              </div>
            </div>
          )
        }
        return (
          <div
            className={`${styles.productListContainer_item} productListContainer_item`}
            style={{ width: multipleOpen ? 'calc(100% - 12px)' : '480px' }}
          >
            <div className={styles.item_imgBox}>
              <Image.PreviewGroup items={item?.productSpu?.imageUrls || undefined}>
                <Image src={item?.productSpuPrimaryImage} />
              </Image.PreviewGroup>
            </div>
            <div className={styles.item_prodBox}>
              <div className={styles.nameBox} onClick={() => clickToDetail(item)}>
                {showNationalTagRender(item?.productSku)}
                {/* <Tooltip title={item.productSpuName}>{item.productSpuName}</Tooltip> */}
                {showProdCateTagRender(item?.productSpu?.prodCateName)}
                {/* <Tooltip
                  title={
                    <div>
                      <div>{item?.productSpu?.prodCateName}</div>
                      <div>{item.productSpuName}</div>
                    </div>
                  }
                > */}
                {item.productSpuName}
                {/* </Tooltip> */}
              </div>
              {(item?.productSpu?.longDesc || item?.longDesc) && (
                <p className={styles.skuCard_longDesc}>
                  <span>工艺说明：</span>
                  <Tooltip
                    title={item?.longDesc || item?.productSpu?.longDesc}
                    placement="topLeft"
                    // overlayStyle={{ maxWidth: '600px' }}
                    autoAdjustOverflow
                  >
                    <span>{item?.longDesc || item?.productSpu?.longDesc}</span>
                  </Tooltip>
                </p>
              )}
              <p className={styles.spuBox}>
                <span>SPU：</span>
                {item?.productSpu?.id}
                <CopyOutlined
                  style={{ marginLeft: '8px' }}
                  className="copyIcon"
                  onClick={() => {
                    clickToCopy(item?.productSpu?.id)
                  }}
                />
              </p>
              <div className={styles.item_bottomBox}>
                <div className={styles.priceBox}>
                  <span className={styles.priceBoxSmall}>￥</span>
                  {<>{item?.priceRange || 0 ? item?.priceRange : '--'}</>}
                  <span className={styles.priceBoxSmall}>/{item?.productSpuUnitName}</span>
                </div>
                {item?.selected ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    size="middle"
                    onClick={() => clickToAdd(item)}
                  >
                    再次添加
                  </Button>
                ) : (
                  <Button type="primary" size="middle" onClick={() => clickToAdd(item)}>
                    添加选材
                  </Button>
                )}
              </div>
            </div>
          </div>
        )
      })}

      {open && (
        <ComfirmModal
          open={open}
          setOpen={setOpen}
          record={record}
          type={type}
          budgetId={budgetId}
          spaceId={spaceId}
          generalId={generalId}
          btnInfo={btnInfo}
          getGeneralList={getGeneralList}
          mode={multipleOpen ? 'multiple' : 'single'}
          setSelectMaterialObj={setSelectMaterialObj}
          reloadProductList={reload}
        ></ComfirmModal>
      )}
    </div>
  )
}
